import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useSnackbar from '@edf-pkg/app-main/src/hooks/use-snackbar';

import { errorHandle } from '$app-web/utils';

export default function useErrorHandler() {
    const { t } = useTranslation();

    const { showError } = useSnackbar();

    const handleError = useCallback(
        (error) => {
            // We usually define error messages and map them to error codes in each react-query endpoint, this line below is implemented to show the BE error message if there were no error message defined in the frontend.
            let messageText;

            // First check if errorExtraInfo is a non-empty string
            const errorExtraInfo = error?.innerError?.data?.errorExtraInfo;
            if (typeof errorExtraInfo === 'string' && errorExtraInfo.trim()) {
                messageText = errorExtraInfo;
            } else if (error.message) {
                // Fallback to error.message
                messageText = error.message;
            } else {
                // Final fallback to error field
                messageText = error?.innerError?.data?.error;
            }

            const errorMessage = typeof messageText === 'string' && messageText.trim() ? messageText : t('generic_error_msg');

            errorHandle.anError(error);

            showError(errorMessage);
        },
        [showError, t]
    );

    return { handleError };
}
